// extracted by mini-css-extract-plugin
export default {"container":"HelpText_container__s7rqa","text":"HelpText_text__RkqQy","icon":"HelpText_icon__6PrJi"};